module.exports = __webpack_public_path__ + "static/img/banner_pc.736b2a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_pc.png
// module id = p1Ac
// module chunks = 5